import React from 'react';

import { HintStyled } from './SelectHint.styled';

type Props = { text: string };

export function SelectHint({ text }: Props): JSX.Element {
  return <HintStyled>{text}</HintStyled>;
}
